import React, { useEffect } from "react";

import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import * as managerApplicantActions from "../../redux/actions/managerApplicantAction";
import AllCaseDetailModalComponent from "../../components/AllCaseDetails/AllCaseDetailModalComponent";

const AllCaseDetailModal = (props) => {
  const dispatch = useDispatch();
  const managerApplicantReducer = useSelector(
    (state) => state.managerApplicantReducer
  );

  const modalAction = bindActionCreators(modalActions, dispatch);
  const managerApplicantAction = bindActionCreators(
    managerApplicantActions,
    dispatch
  );
  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  return (
    <AllCaseDetailModalComponent
      openSetModal={openSetModal}
      closeRemoveModal={closeRemoveModal}
      // caseDetail={}
      {...props}
    />
  );
};
export default AllCaseDetailModal;
